import { SDSText } from '@repo/sds/SDSText';

import { DropdownItem } from '../../../../components/elements/DropdownItem/DropdownItem';

export function EmptySearch() {
  return (
    <DropdownItem>
      <SDSText type="body-medium" text="Nothing has been found yet" className="EmptySearch" color="inactive" />
    </DropdownItem>
  );
}
